<template>
  <div id="mail-form">
    <form @submit.prevent="submitSubscription">
      <div class="form-mr">
        <input v-model="name"
               type="text"
               class="form-mr-input"
               placeholder="name"
               required
        />
      </div>
      <div class="form-mr">
        <input
          v-model="email"
          type="email"
          class="form-mr-input"
          placeholder="name@example.com"
          required
        />
      </div>
      <button type="submit" class="subscribe-button">
        Enter
      </button>
    </form>
  </div>
</template>
<script>
export default {
  name: 'MailForm',
  data: () => ({
    name: '',
    email: '',
    consentPrompt:
      'You can consent to the use of use cookies or similar technologies by hiting the OK button. By closing this notice, you continue without subscribing to stegi.radio newsletter.'
  }),
  methods: {
    submitSubscription() {
      const formData = {
        name: this.name,
        mail: this.email
      };
      if (confirm(this.consentPrompt)) {
        // make the call to API
        console.log(formData);
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_base-mail-form.scss';
</style>
